import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Form, FormGroup, Row, Button } from 'reactstrap';
import { connect, useSelector } from 'react-redux';
import * as jobActions from 'actions/jobActions';
import RenderField from 'components/fields/RenderField';
import SearchableSelect from 'components/fields/SearchableSelect';
import DatePickerField from 'components/fields/DatePickerField';
import * as Validators from 'util/Validators';
import Logger from 'util/Logger';
import { roundToPrevious } from 'util/DateHelper';
import { phosphineRecordsTopupForm } from 'constants/FormConstants';
import { preventEnterSubmit } from 'actions/formActions';
import moment from 'moment';
import {bindActionCreators} from 'redux'

const PhosphineRecordsTopupForm = ({ handleSubmit, canEditJob, splitVessel }) => {
  const technicians = useSelector((state) => state.referenceData.technicians);
  const currentJob = useSelector((state) => state.currentJob);
  
  return (
    <Form onSubmit={handleSubmit} onKeyPress={preventEnterSubmit}>
      <fieldset disabled={!canEditJob}>
        <Row className="align-items-center">
          <FormGroup className="col-lg-6">
            <Field
              name="topUpTechnicianId"
              label="Technician *"
              component={SearchableSelect}
              placeholder="Please select a technician"
              options={technicians}
              valueKey="id"
              labelKey="name"
              validate={Validators.required}
            />
          </FormGroup>
          <FormGroup className="col-lg-6">
            <Field
              name="totalApplied"
              label={`Total Applied ${splitVessel ? '' : '*'}`}
              component={RenderField}
              type="number"
              placeholder="Enter Total"
              validate={
                splitVessel
                  ? [Validators.number]
                  : [Validators.number, Validators.required]
              }
            />
          </FormGroup>
          <FormGroup className="col-lg-6">
            <Field
              name="endDate"
              label="End Date *"
              component={DatePickerField}
              showTimeSelect
              type="text"
              placeholder="dd/mm/yyyy"
              validate={[Validators.isValidDateAndTime, Validators.required]}
              timeIntervals={1}
            />
          </FormGroup>
          <FormGroup className="col-12">
            <Button type="submit" className="mt-3" color="primary">
              Save
            </Button>
          </FormGroup>
        </Row>
      </fieldset>
    </Form>
  );
};

PhosphineRecordsTopupForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  canEditJob: PropTypes.bool.isRequired,
  splitVessel: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, props) => {
  const { currentPhosphineRecord } = props;
  const currentJob = state.currentJob;

  return {
    technicians: state.referenceData.technicians,
    canEditJob: currentJob.canEditJob,
    splitVessel: currentJob && currentJob.exportShipmentDetails &&currentJob.exportShipmentDetails.splitVessel,
    initialValues: currentPhosphineRecord
      ? {
          ...currentPhosphineRecord,
          topUpTechnicianId: currentPhosphineRecord.topUpTechnicianId || currentJob.technicianId,
          endDate: currentPhosphineRecord.endDate || roundToPrevious(moment().startOf('minute'), 5),
          complete: true,
        }
      : null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...jobActions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: phosphineRecordsTopupForm,
    enableReinitialize: true,
    onSubmitFail: (errors, dispatch, submitError) => {
      Logger.error(
        'We were unable to save the changes, please review the fields in red and try again.',
        submitError,
        'Record not saved'
      );
    },
  })(PhosphineRecordsTopupForm)
);
